import LoaderPage from 'components/ui/feedback/LoaderPage'
import { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'

const DashboardListPage = lazy(() => import('pages/dashboard/page'))

const DashboardRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<LoaderPage content={<DashboardListPage />} />} />
    </Routes>
  )
}

export default DashboardRoutes
